import Vector from './../Support/Vector'

/**
 * Base class for all objects that exist in the game
 */
export default class {
    constructor (location) {
        this._id = ('0000' + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4)
        this.world = null
        this.game = null
        this._location = location
        this._velocity = new Vector(0, 0)
    }

    addTo (world) {
        this.world = world
        this.game = world.game
        return this
    }

    getId () {
        return this._id
    }

    update (currentTime) {
        this.updatePosition()
        this.draw(currentTime)
        this.world.grid.update(this)
        return this
    }

    draw (currentTime) {
        this.game.getScene().drawCircle(this.getX(), this.getY())
        return this
    }

    checkWrap () {
        if (this.getX() > this.game.getScene().getWidth()) {
            this.setX(0)
        }
        if (this.getX() < 0) {
            this.setX(this.game.getScene().getWidth())
        }
        if (this.getY() > this.game.getScene().getHeight()) {
            this.setY(0)
        }
        if (this.getY() < 0) {
            this.setY(this.game.getScene().getHeight())
        }

        return this
    }

    updatePosition () {
        this._location.add(this._velocity)
        return this
    }

    getY () {
        return this._location.getY()
    }

    setY (value) {
        this._location.setY(value)
        return this
    }

    getX () {
        return this._location.getX()
    }

    setX (value) {
        this._location.setX(value)
        return this
    }

    getLocation () {
        return this._location.clone()
    }
}
